<div class="arrow-ed-cont p-2">
    <form class="d-block mt-3 p-1">
        <h5>{{ "ARROW_EDITOR_COMPONENT_LABEL" | translate }}</h5>
        <input type="radio" id="yes" name="arrowEnabled" value="true" [(ngModel)]="radioValue" />
        <label for="yes">{{ "ARROW_EDITOR_COMPONENT_YES" | translate }}</label
        ><br />
        <input type="radio" id="no" name="arrowEnabled" value="false" [(ngModel)]="radioValue" />
        <label for="no">{{ "ARROW_EDITOR_COMPONENT_NO" | translate }}</label
        ><br />
    </form>
    <div class="d-flex justify-content-center mt-3">
        <button class="btn w-75 green-btn" (click)="onArrowSave()">
            {{ "ARROW_EDITOR_COMPONENT_SAVE" | translate }}
        </button>
    </div>
    <div class="d-flex justify-content-center mt-3">
        <button class="btn w-75 green-btn" (click)="onClose()">
            {{ "ARROW_EDITOR_COMPONENT_CLOSE" | translate }}
        </button>
    </div>
</div>
